/* eslint import/no-extraneous-dependencies: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint object-shorthand: 0 */
/* eslint dot-notation: 0 */
/* eslint func-names: 0 */
import * as Blockly from 'blockly';
import { FieldSlider } from '@blockly/field-slider';
import { AngleDialField } from './customBlocks/angleDialField';
import { EducabotSliderField } from './customBlocks/sliderField';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// symbol '' porque el ° del plugin ensancha el shadow respecto de prod; precision 1
// porque el plugin redondea a múltiplos de 15 y el legacy no redondea al tipear.
const ANGLE_FIELD_CONFIG = { symbol: '', precision: 1 };


const mathNumberValidator = function (value) {
  const isPwm = this.getSourceBlock().parentBlock_
  let number = 0;
  if (isPwm !== null && isPwm.type === 'math_number_pwm') {
    number = parseFloat(value || 0);
    if (number > 255) {
      number = 255;
    }
    return (Number.isNaN(number) || parseInt(number, 10) < 0) ? null : String(number);
  }
  number = parseFloat(value || 0);
  return Number.isNaN(number) ? null : String(number);
};

Blockly.Blocks.math_number = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour('#ffffff');
    this.appendDummyInput()
      .appendField(new Blockly.FieldTextInput('0', mathNumberValidator), 'NUM');
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg['LANG_MATH_NUMBER_TOOLTIP']);
  },
};

Blockly.Blocks.math_arithmetic = {
  OPERATORS: [
    ['%{BKY_MATH_ADDITION_SYMBOL}', 'ADD'],
    ['%{BKY_MATH_SUBTRACTION_SYMBOL}', 'MINUS'],
    ['%{BKY_MATH_MULTIPLICATION_SYMBOL}', 'MULTIPLY'],
    ['%{BKY_MATH_DIVISION_SYMBOL}', 'DIVIDE'],
    ['%{BKY_MATH_POWER_SYMBOL}', 'POWER'],
  ],
  TOOLTIPS: {
    ADD: Blockly.Msg.MATH_ARITHMETIC_TOOLTIP_ADD,
    MINUS: Blockly.Msg.MATH_ARITHMETIC_TOOLTIP_MINUS,
    MULTIPLY: Blockly.Msg.MATH_ARITHMETIC_TOOLTIP_MULTIPLY,
    DIVIDE: Blockly.Msg.MATH_ARITHMETIC_TOOLTIP_DIVIDE,
    POWER: Blockly.Msg.MATH_ARITHMETIC_TOOLTIP_POWER,
  },
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendValueInput('A')
      .setCheck(Number);
    this.appendValueInput('B')
      .setCheck(Number)
      .appendField(new Blockly.FieldDropdown(this.OPERATORS), 'OP');
    this.setInputsInline(true);
    this.setTooltip(() => {
      const mode = this.getFieldValue('OP');
      return this.TOOLTIPS[mode];
    });
  },
};

Blockly.Blocks.math_single = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendValueInput('NUM')
      .setCheck(Number)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.MATH_SINGLE_OP_ROOT || 'SQR ROOT', 'ROOT'],
        [Blockly.Msg.MATH_SIGNLE_OP_ABS || 'ABS', 'ABS'],
        ['-', 'NEG'],
        ['ln', 'LN'],
        ['log10', 'LOG10'],
        ['e^', 'EXP'],
        ['10^', 'POW10'],
      ]), 'OP');
    this.setTooltip(() => {
      const op = this.getFieldValue('OP');
      return Blockly.Blocks.math_single.TOOLTIPS[op];
    })
  },
};

Blockly.Blocks.math_single.TOOLTIPS = {
  ROOT: Blockly.Msg.MATH_SINGLE_TOOLTIP_ROOT,
  ABS: Blockly.Msg.MATH_SINGLE_TOOLTIP_ABS,
  NEG: Blockly.Msg.MATH_SINGLE_TOOLTIP_NEG,
  LN: Blockly.Msg.MATH_SINGLE_TOOLTIP_LN,
  LOG10: Blockly.Msg.MATH_SINGLE_TOOLTIP_LOG10,
  EXP: Blockly.Msg.MATH_SINGLE_TOOLTIP_EXP,
  POW10: Blockly.Msg.MATH_SINGLE_TOOLTIP_POW10,
};

Blockly.Blocks.math_modulo = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendValueInput('DIVIDEND')
      .setCheck(Number)
    this.appendDummyInput()
      .appendField('%');
    this.appendValueInput('DIVISOR')
      .setCheck(Number);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.MATH_MODULO_TOOLTIP);
  },
}

Blockly.Blocks.advanced_map = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true);
    this.appendValueInput('NUM', Number)
      .appendField(Blockly.Msg.LANG_MATH_ADVANCED_MAP_MAP)
      .setCheck(Number);
    this.appendValueInput('FROM_MIN', Number)
      .appendField(Blockly.Msg.LANG_MATH_ADVANCED_MAP_FROM)
      .setCheck(Number);
    this.appendValueInput('FROM_MAX', Number)
      .appendField(Blockly.Msg.LANG_MATH_ADVANCED_MAP_HYPHEN)
      .setCheck(Number);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATH_ADVANCED_MAP_BRACKET);
    this.appendValueInput('TO_MIN', Number)
      .appendField(Blockly.Msg.LANG_MATH_ADVANCED_MAP_TO)
      .setCheck(Number);
    this.appendValueInput('TO_MAX', Number)
      .appendField(Blockly.Msg.LANG_MATH_ADVANCED_MAP_HYPHEN)
      .setCheck(Number);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATH_ADVANCED_MAP_BRACKET);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_ADVANCED_MAP_TOOLTIP);
  },
}

// Produce "valor,BASE" para ir dentro de serial_print -> Serial.print(valor, HEX).
Blockly.Blocks.advanced_conversion = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ADVANCED_CONVERSION_CONVERT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_ADVANCED_CONVERSION_DECIMAL || 'DEC', 'DEC'],
        [Blockly.Msg.LANG_ADVANCED_CONVERSION_HEXADECIMAL || 'HEX', 'HEX'],
        [Blockly.Msg.LANG_ADVANCED_CONVERSION_OCTAL || 'OCT', 'OCT'],
        [Blockly.Msg.LANG_ADVANCED_CONVERSION_BINARY || 'BIN', 'BIN'],
      ]), 'CONV');
    this.appendValueInput('NUM')
      .appendField(Blockly.Msg.LANG_ADVANCED_CONVERSION_VALUE)
      .setAlign(Blockly.inputs.Align.RIGHT)
      .setCheck(Number);
    // Sin declararlo, v13 parte el bloque en dos filas y prod lo dibuja en una.
    this.setInputsInline(true);
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ADVANCED_CONVERSION_TOOLTIP);
  },
}

Blockly.Blocks.math_array = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATH_ARRAY_ARRAY3)
      .appendField(Blockly.Msg.LANG_MATH_ARRAY_BRACKET3)
      .appendField(new Blockly.FieldTextInput('0', mathNumberValidator), 'NUM0')
      .appendField(Blockly.Msg.LANG_MATH_ARRAY_COMMA);
    this.appendDummyInput()
      .appendField(new Blockly.FieldTextInput('0', mathNumberValidator), 'NUM1')
      .appendField(Blockly.Msg.LANG_MATH_ARRAY_COMMA);
    this.appendDummyInput()
      .appendField(new Blockly.FieldTextInput('0', mathNumberValidator), 'NUM2')
      .appendField(Blockly.Msg.LANG_MATH_ARRAY_BRACKET4);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_ARRAY_TOOLTIP);
  },
}

Blockly.Blocks.math_random = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendValueInput('NUM', Number)
      .appendField(Blockly.Msg.LANG_ADVANCED_MATH_RANDOM)
      .setCheck(Number);
    this.appendValueInput('DMAX', Number)
      .appendField(Blockly.Msg.LANG_ADVANCED_MATH_RANDOM_AND)
      .setCheck(Number);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_ADVANCED_MATH_RANDOM_TOOLTIP);
  },
}

Blockly.Blocks.math_number_pwm = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendValueInput('NUM', Number)
      .appendField(Blockly.Msg.LANG_MATH_PWM)
      .setCheck(Number);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
}

Blockly.Blocks.math_number_minmax = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new EducabotSliderField(0, 0, 255, 1, undefined, { labelText: 'Intensidad de brillo' }), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
}

Blockly.Blocks.math_number_minmax_analog = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new EducabotSliderField(1023, 0, 1023, 1, undefined, { labelText: 'Intensidad de brillo' }), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
}

// Pliega el valor en vez de recortarlo, como el legacy.
const angleValidator = function (text) {
  if (text === null) return null;
  let n = parseFloat(text || 0);
  if (Number.isNaN(n)) return null;
  n %= 360;
  if (n < 0) n += 360;
  if (n > 180) n -= 180;
  return String(n);
};

Blockly.Blocks.slider_angle = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new AngleDialField(90, angleValidator, ANGLE_FIELD_CONFIG), 'angulo');
  },
}

const angle270Validator = function (text) {
  if (text === null) return null;
  let n = parseFloat(text || 0);
  if (Number.isNaN(n)) return null;
  n %= 360;
  if (n < 0) n += 360;
  if (n > 270) n -= 270;
  return String(n);
};

Blockly.Blocks.slider_angle_270 = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new AngleDialField(90, angle270Validator, ANGLE_FIELD_CONFIG), 'angulo');
  },
}

// Rango completo porque el motor omnidireccional acepta cualquier dirección.
// Difiere del legacy solo en el caso >359.
const angleIacoValidator = function (text) {
  if (text === null) return null;
  let n = parseFloat(text || 0);
  if (Number.isNaN(n)) return null;
  n %= 360;
  if (n < 0) n += 360;
  if (n > 359) n -= 359;
  return String(n);
};

Blockly.Blocks.slider_angle_iaco = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new AngleDialField(90, angleIacoValidator, ANGLE_FIELD_CONFIG), 'angulo');
  },
}

Blockly.Blocks.math_number_minmax_speed_1023 = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new EducabotSliderField(1023, 0, 1023, 1, undefined, { labelText: 'Velocidad' }), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
}

Blockly.Blocks.math_number_minmax_speed = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new EducabotSliderField(255, 0, 255, 1, undefined, { labelText: 'Velocidad' }), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
}

// 0-100 porque la lib del servo interpreta el valor como porcentaje de velocidad.
Blockly.Blocks.math_number_minmax_speed_100 = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new EducabotSliderField(100, 0, 100, 1, undefined, { labelText: 'Velocidad' }), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
}

Blockly.Blocks.math_number_minmax_oled_x = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new EducabotSliderField(0, 0, 128, 1, undefined, { labelText: 'Número de posición' }), 'POSITION');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
}

Blockly.Blocks.math_number_minmax_oled_y = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new EducabotSliderField(0, 0, 64, 1, undefined, { labelText: 'Número de posición' }), 'POSITION');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
}

Blockly.Blocks.math_number_minmax_matrix8x8 = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new EducabotSliderField(0, 0, 7, 1, undefined, { labelText: 'Número de posición' }), 'POSITION');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
}

// Shadows del drone (Tello): textos hardcodeados en español, ver droneBlocks.js.
const angle360Validator = function (text) {
  if (text === null) return null;
  let n = parseFloat(text || 0);
  if (Number.isNaN(n)) return null;
  n %= 360;
  if (n < 0) n += 360;
  return String(n);
};

Blockly.Blocks.slider_angle_360 = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new AngleDialField(90, angle360Validator, ANGLE_FIELD_CONFIG), 'angulo');
  },
};

Blockly.Blocks.math_speed_min_max = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new FieldSlider(15, 10, 100, 1), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip('Velocidad (cm/s)');
  },
};

// Rango que acepta el comando curve del Tello.
Blockly.Blocks.math_speed_10_60 = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new FieldSlider(15, 10, 60, 1), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip('Velocidad (cm/s)');
  },
};

Blockly.Blocks.math_distancia_min_max = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new FieldSlider(20, 20, 500, 1), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip('Distancia (cm)');
  },
};

// fly_xyz y curve aceptan coordenadas negativas, de ahí el rango simétrico.
Blockly.Blocks.math_distancia_500_500 = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new FieldSlider(15, -500, 500, 1), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip('Distancia (cm)');
  },
};
